<div class="container blog-carousel-container">
  <div style="position: relative;">
    <swiper-container #swiper init="false">
      <swiper-slide *ngFor="let post of posts">
        <div class="post-item">
          <a [routerLink]="[post.routerLink]" class="image-link">
            <div class="aspect-ratio-box">
              <div class="aspect-ratio-box-inside">
                <picture *ngIf="post.homePictureUrl">
                  <source [attr.defaultImage]="settings?.holdingImage?.medium" [attr.lazyLoad]="post.homePictureUrl + '.webp'" type="image/webp" />
                  <img [defaultImage]="settings?.holdingImage?.medium" [lazyLoad]="post.homePictureUrl" [alt]="post.title" />
                </picture>
              </div>
            </div>
          </a>
          <div class="d-flex flex-row flex-wrap justify-content-start">
            <div class="title-overlay">
              <span class="post-title">> {{post.title}}</span>
              <span *ngIf="post.bodyOverview" class="post-overview">{{post.bodyOverview}}</span>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper-container>
    <div class="swiper-button-prev-blog">
      <button mat-mini-fab disabled aria-label="Previous">
        <mat-icon color="primary">chevron_left</mat-icon>
      </button>
    </div>
    <div class="swiper-button-next-blog">
      <button mat-mini-fab disabled aria-label="Next">
        <mat-icon color="primary">chevron_right</mat-icon>
      </button>
    </div>
  </div>
</div>
